var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 120,
    cy: 120,
    r: 120,
    fill: "#F66700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.333 103.333C133.333 106.87 131.928 110.261 129.428 112.761C126.927 115.262 123.536 116.667 120 116.667C116.464 116.667 113.072 115.262 110.572 112.761C108.071 110.261 106.667 106.87 106.667 103.333C106.667 99.7971 108.071 96.4057 110.572 93.9052C113.072 91.4048 116.464 90 120 90C123.536 90 126.927 91.4048 129.428 93.9052C131.928 96.4057 133.333 99.7971 133.333 103.333V103.333ZM120 126.667C113.811 126.667 107.877 129.125 103.501 133.501C99.1248 137.877 96.6665 143.812 96.6665 150H143.333C143.333 143.812 140.875 137.877 136.499 133.501C132.123 129.125 126.188 126.667 120 126.667V126.667Z",
    stroke: "#F66700",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.8cf8e71b8da5b4051e463de36ec5c73f.svg";
export { ForwardRef as ReactComponent };